import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setCurrentClient } from '../../../actions/client'
import { defineMessages, FormattedMessage } from 'react-intl'
import { Button, If, Input, Modal, Text } from '../../../Components'
import ModalView from '../../../Components/shared/Modal/Modal'
import { FORM_PLACEHOLDERS } from '../../../constants/messages'
import { SSO_REDIRECT_URI } from '../../../constants/auth'

import styles from './AuthError.module.scss'

const MESSAGES = defineMessages({
  title: {
    id: 'AuthorizationModal.title',
    defaultMessage: 'This link has expired to protect your security.',
  },
})

const AuthError = ({
  buyerId,
  intl,
  onSubmit,
  email,
  setEmail,
  complete,
  routeKey,
}) => {
  const dispatch = useDispatch()

  useEffect(() => () => dispatch(setCurrentClient(null)), [dispatch])

  return (
    <Modal
      openKey={routeKey === 'home' ? 'home.errorModal' : 'buyerInfo.errorModal'}
      title={intl.formatMessage(MESSAGES.title)}
      overrideContent={complete}
    >
      <If condition={!complete}>
        <Text size='s' variant='neutralCool' variantCount='900'>
          <If condition={routeKey === 'buy'}>
            <FormattedMessage
              id='AuthorizationModal.beforeField'
              defaultMessage='Please confirm your email address to receive an updated Market Report'
            />
          </If>
          <If condition={routeKey === 'home'}>
            <FormattedMessage
              id='AuthorizationModal.beforeField.homeowner'
              defaultMessage='Please confirm your email address to receive an updated home value estimate'
            />
          </If>
        </Text>
        <form className={styles.inputContainer} onSubmit={onSubmit}>
          <Input
            placeholder={intl.formatMessage(FORM_PLACEHOLDERS.email)}
            className={styles.input}
            value={email}
            onChange={setEmail}
            required
            type='email'
            aria-label='email input'
          />
          <Button type='submit'>
            <FormattedMessage
              id='AuthorizationModal.submitButton'
              defaultMessage='Submit'
            />
          </Button>
        </form>
        <Text size='s' variant='neutralCool' variantCount='900'>
          <FormattedMessage
            id='AuthorizationModal.afterField'
            defaultMessage="If you're a Homebot real estate agent or lender, please {loginLink}"
            values={{
              loginLink: (
                <a href={SSO_REDIRECT_URI}>
                  <FormattedMessage
                    id='AuthorizationModal.loginLinkText'
                    defaultMessage='log in'
                  />
                </a>
              ),
            }}
          />
        </Text>
      </If>
      <If condition={complete}>
        <ModalView.Inner>
          <Text
            className={styles.successText}
            variant='neutralCool'
            variantCount='900'
          >
            <If condition={routeKey === 'buy'}>
              <FormattedMessage
                id='AuthorizationModal.successMessage'
                defaultMessage="Updated Market Report sent to the address provided. If you're still having issues, please contact your agent."
              />
            </If>
            <If condition={routeKey === 'home'}>
              <FormattedMessage
                id='AuthorizationModal.successMessage.homeowner'
                defaultMessage="Updated home value estimate sent to the address provided. If you're still having issues, please contact your agent."
              />
            </If>
          </Text>
        </ModalView.Inner>
      </If>
    </Modal>
  )
}

export default AuthError
